import * as actionTypes from '../actions/actionTypes';

const initialState = {
  loading: false,
  data: [],
};

const fullfilmentMemberListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FULLFILMENT_MEMBER_LIST_LOADING:
      return {
        loading: true,
        data: [],
      };
    case actionTypes.FULLFILMENT_MEMBER_LIST_SUCCESS:
      return {
        loading: false,
        data: action.payload,
      };
    case actionTypes.FULLFILMENT_MEMBER_LIST_FAILURE:
      return {
        data: [],
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default fullfilmentMemberListReducer;
